import React, { useRef, useState } from 'react'

import { Route, Routes } from 'react-router-dom'
import { Global } from '@emotion/react'
import GlobalStyles from '@styles/GlobalStyle'
import Layout from '@layout/Layout'
import HomePage from '@pages/home/HomePage'
import VideoPage from '@pages/video/VideoPage'

const App = () => {
  const [selectedDiv, setSelectedDiv] = useState(0)
  const coreTechnologyRef = useRef<HTMLDivElement>(null)
  const mainSkillRef = useRef<HTMLDivElement>(null)
  const partnerRef = useRef<HTMLDivElement>(null)

  return (
    <>
      <Global styles={GlobalStyles} />
      <div className="App">
        <Routes>
          <Route
            path="/"
            element={
              <Layout>
                <HomePage
                  setSelectedDiv={setSelectedDiv}
                  coreTechnologyRef={coreTechnologyRef}
                  mainSkillRef={mainSkillRef}
                  partnerRef={partnerRef}
                />
              </Layout>
            }
          />
          <Route path="/video" element={<VideoPage />} />
        </Routes>
      </div>
    </>
  )
}

export default App
